import gql from 'graphql-tag';

const GET_VENDOR_OPPORTUNITY_NOTES_QUERY = gql`
  query VendorOpportunityNotes($id: ID!) {
    vendorOpportunity(id: $id) {
      notes
    }
  }
`;

export const voNotesApi = {
  getNotes: GET_VENDOR_OPPORTUNITY_NOTES_QUERY,
};
